module.exports = __webpack_public_path__ + "asset/image-google-play-download-101601e3b08a2a82.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/scene/landing/image/google-play-download.png
// module id = tTca
// module chunks = 1